import React from "react";
import ReactDOM from  "react-dom";
import { wrapCurrentUser } from "../../mixins/wrap_current_user";
import { logout } from "../../util/login";
import { getCurrentRoutePath, isPathSignup, isPathLogin, isPathAccountSignup, SIGNUP_PATH, ACCOUNT_SIGNUP_PATH, LOGIN_PATH, navigateTo } from "../../util/route";
import Template from "./metype_home.rt";
import { subscribePlan, createAccount } from "../../gateway/backend";

@wrapCurrentUser
export default class Home extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openContactUsModal: false,
      disableGetStartedButton: false,
      selectedPlans:[],
      spinner: false
    }

    this.toggleContactUs = this.toggleContactUs.bind(this);
    this.getSubscription = this.getSubscription.bind(this);
    this.toggleAccountSignupModal = this.toggleAccountSignupModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.getFreePlan = this.getFreePlan.bind();
    this.closeAccountSignUpModal = this.closeAccountSignUpModal.bind(this);
    this.handleAccountPlanSelection = this.handleAccountPlanSelection.bind(this);

    const currentPath = getCurrentRoutePath();
    if (isPathSignup(currentPath) || isPathLogin(currentPath) || isPathAccountSignup(currentPath)) {
      document.body.style.overflow = 'hidden';
    }
    
    this.showAuthModal = isPathSignup(currentPath) || isPathLogin(currentPath);
    this.showAccountSignupModal = isPathAccountSignup(getCurrentRoutePath());
  }

  getFreePlan(){
    return talktype.config.plans ? talktype.config.plans.find( plan => plan.name === "Standard") : {};
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  userLogin() {
    window.location = '/admin'
  }

  closeAccountSignUpModal() {
    window.location = '/'
  }

  toggleListComponent(action = "") {
    if(action === 'getStarted') {
      if (this.props.signedIn) {
        navigateTo(ACCOUNT_SIGNUP_PATH);
      } else {
        navigateTo(SIGNUP_PATH);
      }
    }
    else {
      navigateTo(LOGIN_PATH);
    }
  }

  closeLogin() {
    window.location = '/'
  }

  toggleContactUs() {
    this.setState({openContactUsModal: !this.state.openContactUsModal}, () => this.toggleScroll());
  }

  toggleAccountSignupModal(planName) {
    window.location = `${ACCOUNT_SIGNUP_PATH}?plan_name=${planName}`;
  }

  handleAccountPlanSelection (planName) {
    if(planName) {
      var planeDetails= talktype.config.plans ? talktype.config.plans.find( plan => plan.name === planName) : {};

      if (planeDetails===undefined) {
          planeDetails=[];
      }
      planeDetails['count']=Object.keys(planeDetails).length;
      this.setState({
        selectedPlans: planeDetails
      }, () => this.toggleScroll());
    }
  }

  toggleScroll() {
    if((this.state.openContactUsModal || this.showAccountSignupModal)) {
      document.body.classList.add("scroll-disable");
    }
    else {
      document.body.classList.remove("scroll-disable");
    }
  }

  onSubmit(event, accountDetails, planValues) {
    if(this.state.disableGetStartedButton) return false;
    const form = event.target.parentElement;
    if(form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({disableGetStartedButton: true , spinner: !this.state.spinner });
      this.getSubscription(planValues, accountDetails);
    }
  }

  getSubscription(planValues, accountDetails) {
      subscribePlan(this.props.currentUser.id)
      .then((response)=> this.createAccount(response, accountDetails));
  }

  createAccount(response, accountDetails) {
    const accountDetailsRazorpayIds = {...accountDetails, subscription_id: response["id"]};
    createAccount(this.props.currentUser.id, accountDetailsRazorpayIds)
    .then(() => {
      this.redirectToAdminPage();
    });
  }

  redirectToAdminPage() {
    window.location.href = "/admin";
  }

  focusDiv(event) {
    if(event.target.id == 'metype-header-menubar-features') {
       window.location.href="#features";
     }
    else if(event.target.id == 'metype-header-menubar-pricing') {
      window.location.href="#pricing";
    }
  }

  signOut(loginObj={}) {
    logout();
  }

  redirectLink() {
    return ((this.props.currentUser.accounts) ? '/admin' : '/dashboard');
  }

  componentDidUpdate () {
    if (isPathAccountSignup(getCurrentRoutePath()) && !this.props.signedIn) {
      this.toggleListComponent('getStarted')
    }
    if (this.showAuthModal && this.props.signedIn) {
      window.location.href = "/"
    }
    if (isPathAccountSignup(getCurrentRoutePath())) {
      const planName = new URLSearchParams(window.location.search).get('plan_name')
      if (planName && (this.state.selectedPlans.length === 0 || this.state.selectedPlans.name !== planName)) {
        this.handleAccountPlanSelection(planName)
      }
    }
  }

  render() {
    return Template.call(this);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/metype_home/metype_home.js